// extracted by mini-css-extract-plugin
export var cardContainer = "_py-0";
export var cardHeader = "_py-2";
export var collapsedState = "_py-3";
export var dragHandle = "_py-5";
export var dragHandleIcon = "_py-6";
export var dragging = "_py-1";
export var titleArea = "_py-4";